import store from 'shared/store'
import { showModalAction } from 'shared/store/ducks/events'
import { LOGIN_MODAL_ID } from 'views/consts'
import { PRODUCT_STATUS_AV, PRODUCT_STATUS_NL } from 'shared/consts/stockStatus'

import { ARIA_HIDDEN } from 'views/assets/scripts/consts'
import {
  buyboxPersonalAdviceLinkSelector,
  buyboxSubscriptionLinkSelector,
  buyboxSubscriptionLinkTriggerSelector,
  aboModalSubscriptionLinkSelector,
  aboModalSubscriptionLinkTriggerSelector,
  productListAboSubscriptionLinkSelector,
  headerAboLinkSelector,
  productDescriptionPersonalAdviceLinkSelector,
  productLabelAboSelector,
  rootElementSelector,
  loginFormErrorNotificationSelector,
  loginFormDescriptionSelector
} from './selectors'

export const setAriaHidden = (element, value) => {
  if (element) {
    element.setAttribute(ARIA_HIDDEN, value)
  }
}

export const showLoginFormWithErrorMessage = () => {
  const loginFormErrorNotificationElement = document.querySelector(
    loginFormErrorNotificationSelector
  )

  const loginFormDescriptionElement = document.querySelector(
    loginFormDescriptionSelector
  )

  if (loginFormErrorNotificationElement !== null) {
    loginFormErrorNotificationElement.removeAttribute(ARIA_HIDDEN)
  }

  if (loginFormDescriptionElement !== null) {
    loginFormDescriptionElement.setAttribute(ARIA_HIDDEN, 'true')
  }

  store.dispatch(showModalAction(LOGIN_MODAL_ID))
}

export const showLoginForm = () => {
  store.dispatch(showModalAction(LOGIN_MODAL_ID))
}

export const getProductIDForProductListing = link => {
  return link.getAttribute('data-qa-id').replace('form-', '')
}

export const getSubscriptionElements = () => {
  const buyboxSubscriptionLink = document.querySelector(
    buyboxSubscriptionLinkSelector
  )
  const aboModalSubscriptionLink = document.querySelector(
    aboModalSubscriptionLinkSelector
  )
  const productListAboSubscriptionLink = document.querySelectorAll(
    productListAboSubscriptionLinkSelector
  )

  const productDescriptionPersonalAdviceLink = document.querySelector(
    productDescriptionPersonalAdviceLinkSelector
  )
  const buyboxPersonalAdviceLink = document.querySelector(
    buyboxPersonalAdviceLinkSelector
  )
  const productLabelAboElement = document.querySelector(productLabelAboSelector)
  const headerAboLink = document.querySelector(headerAboLinkSelector)
  const rootElement = document.querySelector(rootElementSelector)

  const createSubscriptionLink = []
  if (buyboxSubscriptionLink) {
    createSubscriptionLink.push(
      buyboxSubscriptionLink.querySelector(
        buyboxSubscriptionLinkTriggerSelector
      )
    )
  } else if (productListAboSubscriptionLink) {
    productListAboSubscriptionLink.forEach(aboProduct => {
      createSubscriptionLink.push(aboProduct.querySelector('a'))
    })
  }

  let createSubscriptionLinkModal
  if (aboModalSubscriptionLink) {
    createSubscriptionLinkModal = aboModalSubscriptionLink.querySelector(
      aboModalSubscriptionLinkTriggerSelector
    )
  }

  return {
    buyboxPersonalAdviceLink,
    productDescriptionPersonalAdviceLink,
    productLabelAboElement,
    rootElement,
    headerAboLink,
    buyboxSubscriptionLink,
    createSubscriptionLinkModal,
    createSubscriptionLink
  }
}

// eslint-disable-next-line complexity
export const changeVisibilitySubscriptionElements = ({
  buyboxSubscriptionLink,
  buyboxPersonalAdviceLink,
  productDescriptionPersonalAdviceLink,
  subscriptionService = false,
  isSubscriptionProduct,
  productStockStatus,
  productLabelAboElement,
  headerAboLink,
  isLoggedIn
}) => {
  const isProductElegibleForSubscription =
    subscriptionService && isSubscriptionProduct && isLoggedIn
  const showOnlyMySubscriptionInMenu =
    subscriptionService && !isSubscriptionProduct && isLoggedIn
  const isProductElegibleForSubscriptionButUserLoggedOut =
    isSubscriptionProduct && !isLoggedIn
  const hideAboActions =
    productStockStatus === PRODUCT_STATUS_AV ||
    productStockStatus === PRODUCT_STATUS_NL

  if (isProductElegibleForSubscription) {
    // 1. we enable abo in the menu (header)
    setAriaHidden(headerAboLink, false)
    // 2. we hide personal advice in buybox and show it in descriptions
    setAriaHidden(productDescriptionPersonalAdviceLink, false)
    setAriaHidden(buyboxPersonalAdviceLink, true)
    // 3. we show subscription link in buybox
    setAriaHidden(buyboxSubscriptionLink, false)
    // 4. we enable product label on product sub-header
    setAriaHidden(productLabelAboElement, false)

    if (hideAboActions) {
      setAriaHidden(productLabelAboElement, true)
      setAriaHidden(buyboxSubscriptionLink, true)
    }
    return
  }

  if (showOnlyMySubscriptionInMenu) {
    // 1. we enable abo in the menu (header)
    setAriaHidden(headerAboLink, false)
    // 2. personal advice stays in buybox and it's hidden in description
    setAriaHidden(productDescriptionPersonalAdviceLink, true)
    setAriaHidden(buyboxPersonalAdviceLink, false)
    // 3. we hide subscription link in buybox
    setAriaHidden(buyboxSubscriptionLink, true)
    // 4. we hide product label on product sub-header
    setAriaHidden(productLabelAboElement, true)
    return
  }

  if (isProductElegibleForSubscriptionButUserLoggedOut) {
    // 1. we show logged-out menu in the header (without abo)
    setAriaHidden(headerAboLink, true)
    // 2. we hide personal advice in buybox and show it in descriptions
    setAriaHidden(productDescriptionPersonalAdviceLink, false)
    setAriaHidden(buyboxPersonalAdviceLink, true)
    // 3. we show subscription link in buybox
    setAriaHidden(buyboxSubscriptionLink, false)
    // 4. we enable product label on product sub-header
    setAriaHidden(productLabelAboElement, false)

    if (hideAboActions) {
      setAriaHidden(productLabelAboElement, true)
      setAriaHidden(buyboxSubscriptionLink, true)
    }
  }
}
